import { useState } from 'react';

/**
 * useState that persists the value in localStorage.
 * Falls back to defaultValue if nothing is stored or parsing fails.
 */
export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored !== null ? JSON.parse(stored) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const setAndPersist = (next) => {
    const resolved = typeof next === 'function' ? next(value) : next;
    setValue(resolved);
    try {
      localStorage.setItem(key, JSON.stringify(resolved));
    } catch {
      // quota exceeded or private mode — silently ignore
    }
  };

  return [value, setAndPersist];
};
